import React from 'react';
import { EnergyblocksSvgIcon } from '../icons/IconProvider';

const AuthHeaderTextComponent = ({ title, desc }) => {
  return (
    <>
      <div className="mx-auto w-32">
        <EnergyblocksSvgIcon />
      </div>
      <h4 className="mb-3 mt-4 text-center">{title || ''}</h4>
      <p className="mb-5 text-sm text-[#85919F] text-center">{desc || ''} </p>
    </>
  );
};
export default AuthHeaderTextComponent;
